<h2 mat-dialog-title class="av-section-title">{{ 'backoffice.subscriptions.overrides.dialog_title' | translate }}</h2>

<mat-dialog-content class="d-flex flex-column gap-3">
  <p class="av-section-hint m-0">{{ 'backoffice.subscriptions.overrides.hint' | translate }}</p>

  <dl class="d-flex flex-column gap-2 m-0">
    <div class="d-flex justify-content-between gap-3">
      <dt class="av-meta">{{ 'backoffice.common.reason_dialog.organization' | translate }}</dt>
      <dd class="m-0 cell-strong text-end">{{ data.organizationName }}</dd>
    </div>

    <div class="d-flex justify-content-between gap-3">
      <dt class="av-meta">{{ 'backoffice.subscriptions.overrides.component' | translate }}</dt>
      <dd class="m-0 text-end">{{ data.componentLabelKey | translate }}</dd>
    </div>

    <div class="d-flex justify-content-between gap-3">
      <dt class="av-meta">{{ 'backoffice.subscriptions.overrides.current_unit_amount' | translate }}</dt>
      <dd class="m-0 text-end" data-testid="override-current-amount">
        {{ data.currentUnitAmount }} {{ data.currency || '' }}
      </dd>
    </div>
  </dl>

  @if (data.hasActiveOverride) {
    <div class="av-banner p-3 d-flex align-items-start gap-2" data-testid="override-already-active">
      <mat-icon aria-hidden="true">block</mat-icon>
      <span>{{ 'backoffice.subscriptions.overrides.already_active' | translate }}</span>
    </div>
  }

  <form [formGroup]="formGroup" class="d-flex flex-column gap-3">
    <label class="d-flex flex-column gap-1" for="override-amount">
      <span class="av-meta">{{ 'backoffice.subscriptions.overrides.amount_label' | translate }}</span>
      <input
        id="override-amount"
        type="number"
        step="0.01"
        min="0"
        class="av-field"
        [attr.max]="amountMax"
        formControlName="override_unit_amount"
        data-testid="override-amount-input"
      />
    </label>

    @if (!isDiscount()) {
      <p class="av-meta m-0" data-testid="override-not-a-discount">{{ 'backoffice.subscriptions.overrides.not_a_discount' | translate }}</p>
    }

    <label class="d-flex flex-column gap-1" for="override-ends-at">
      <span class="av-meta">{{ 'backoffice.subscriptions.overrides.ends_at_label' | translate }}</span>
      <input id="override-ends-at" type="date" class="av-field" formControlName="ends_at" />
    </label>

    <p class="av-meta m-0">{{ 'backoffice.subscriptions.overrides.ends_at_hint' | translate }}</p>

    <label class="d-flex flex-column gap-1" for="override-reason">
      <span class="av-meta">{{ 'backoffice.licences.reason' | translate }}</span>
      <textarea
        id="override-reason"
        class="av-field"
        rows="3"
        [attr.maxlength]="reasonMax"
        formControlName="reason"
        data-testid="override-reason"
      ></textarea>
    </label>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="d-flex justify-content-end gap-2">
  <button type="button" class="av-btn" (click)="dismiss()">{{ 'backoffice.common.actions.cancel' | translate }}</button>

  <button
    type="button"
    class="av-btn av-btn-primary"
    [disabled]="!formGroup.valid || !isDiscount() || data.hasActiveOverride"
    (click)="confirm()"
    data-testid="override-submit"
  >
    {{ 'backoffice.subscriptions.overrides.submit' | translate }}
  </button>
</mat-dialog-actions>
